import { SUBSPECS } from '../data/subspecs';
import type { ArchetypeId, EquippedGear, GearSlot, Rarity, Tier } from '../model/types';
import type { BuildState } from '../model/types';

export interface GearLayer {
  tier: Tier;
  rarity: Rarity;
  enhance: number;
}

/** One painted layer per visible slot. Placeholder shapes stand in until hand-painted art exists. */
export interface HeroFigure {
  level: number;
  heart: ArchetypeId | null;
  marks: Array<ArchetypeId | null>;
  layers: Partial<Record<GearSlot, GearLayer>>;
  averageEnhance: number;
}

export function heroFigure(build: BuildState, gear: EquippedGear, level: number): HeroFigure {
  const marks: Array<ArchetypeId | null> = [build.primary, build.secondary, build.tertiary].map((id) =>
    id ? SUBSPECS[id].archetype : null,
  );
  const layers: HeroFigure['layers'] = {};
  let enhanceSum = 0;
  let enhanceCount = 0;
  for (const [slot, item] of Object.entries(gear) as [GearSlot, EquippedGear[GearSlot]][]) {
    if (!item) continue;
    layers[slot] = { tier: item.tier, rarity: item.rarity, enhance: item.enhance };
    enhanceSum += item.enhance;
    enhanceCount += 1;
  }
  return {
    level,
    heart: marks[0] ?? null,
    marks,
    layers,
    averageEnhance: enhanceCount === 0 ? 0 : enhanceSum / enhanceCount,
  };
}
